
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { AppMessage } from '@/models/appMessage';

@Component({
    name: 'AppMessage',
})
export default class AppMessageToast extends Vue {
    @Prop({
        required: true,
    })
    private appMessage: AppMessage;

    private messageStyle() {
        return {
            color: this.appMessage.font_color,
            backgroundColor: this.appMessage.background_color,
            fontSize: this.appMessage.font_size + 'px',
        };
    }
}
